import { createSelector } from '@ngrx/store';

import { businessEntitiesFeature } from './business-entities.feature';

export const selectBusinessEntitiesState = businessEntitiesFeature.selectBusinessEntitiesState;
export const selectBusinessEntitiesData = createSelector(
  selectBusinessEntitiesState,
  (s) => s.businessEntities,
);
export const selectBusinessEntitiesLoading = businessEntitiesFeature.selectLoading;
